export { RouteGuardProps } from './types'
export * from './guarded-route'



// WEBPACK FOOTER //
// ./src/modules/router/index.ts